import React from "react"
import {
  Cart as CartComponent
} from '../components/cart';

const Cart = () => <CartComponent />

export default Cart
